import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import { cn, DateintConvert, intDateConvert } from 'src/lib/utils'
import { t } from 'i18next'
import { BiInfoCircle } from 'react-icons/bi'
import { Checkbox } from 'src/Common/ui/checkbox'
import { RadioGroup, RadioGroupItem } from 'src/Common/ui/radio-group'
import { Popover, PopoverTrigger, PopoverContent } from 'src/Common/ui/popover'
import { COMPLIANCE_INFO_DATA } from 'src/Entities/ConfigurationEntity'
import SelectInput from 'src/Common/ui/selectInput'
import DatePickerInput from 'src/Common/ui/DatePickerInput'

const ConfigurationView = ({
    selectedKindId, data, onValueChange, endMonth, isInitial, handleSelect, temporaryConfigurationData, setTemporaryConfigurationData
}) => {
    const { control, errors, register } = useForm()
    const latestModifiedDate = data => {
        if (!data || data?.length === 0) return 'Last Updated: -'
        const latestItem = data?.reduce((latest, item) =>
            new Date(item.modifiedAt) > new Date(latest.modifiedAt) ? item : latest
        )

        const formattedDate = new Date(latestItem.modifiedAt).toLocaleString('en-US', {
            day: '2-digit',
            month: 'short', // "Feb" instead of "February"
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true // "AM/PM" format
        })

        return isInitial ? '' : `Last Updated: ${formattedDate}`
    }
    const listMonths = [
        { label: 'Jan', value: 1 },
        { label: 'Feb', value: 2 },
        { label: 'Mar', value: 3 },
        { label: 'Apr', value: 4 },
        { label: 'May', value: 5 },
        { label: 'Jun', value: 6 },
        { label: 'Jul', value: 7 },
        { label: 'Aug', value: 8 },
        { label: 'Sep', value: 9 },
        { label: 'Oct', value: 10 },
        { label: 'Nov', value: 11 },
        { label: 'Dec', value: 12 }
    ]
    const handleSelectFieldChange = (e) => {
        console.log(e)
        const date = new Date(e)
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        handleSelect(DateintConvert(localDate), 15)
    }
    const minDate = new Date()
    minDate.setDate(1)
    minDate.setMonth(data.find(el => el.subtitleName === 'Start Month')?.values - 1)
    return (
        <>{selectedKindId === 1 &&

            <div>
                <div className="flex justify-between my-2">
                    <div className='flex justify-between'>
                        <div className='text-muted text-lg font-semibold'>Soft Target</div>
                    </div>
                    <Popover>
                        <PopoverTrigger>
                            <BiInfoCircle size={20} className='text-primary' />
                        </PopoverTrigger>
                        <PopoverContent
                            className="w-100 p-3  shadow-lg border rounded-lg"
                            side="bottom"
                            align="end"
                        >
                            <p className="font-semibold text-primary mb-2">Info</p>
                            <hr className="border-primary-400 mb-1" />
                            <ul className="space-y-2">
                                {COMPLIANCE_INFO_DATA.map((item) => (
                                    <li key={item.label} className="flex justify-between text-sm text-gray-700">
                                        <span className="text-primary font-medium">{item.label}</span>
                                        <span>- Maximum cutoff of {item.days} days</span>
                                    </li>
                                ))}
                            </ul>
                        </PopoverContent>
                    </Popover>
                </div>

                <div className='flex flex-wrap gap-4'>
                    {data.map((item, index) => {
                        if (item?.titleName === 'Assessment Cycle' || item?.titleName === 'Effective Date') return null
                        return (

                            <div key={index} className='w-full sm:w-1/2 md:w-[32%]'>
                                <div className='text-muted flex text-md font-semibold'>{item.titleName}</div>
                                <div className='flex w-[80%] rounded-lg mt-[10px] ring-[1.5px] ring-[hsl(var(--border))] shadow-sm'>
                                    <Controller
                                        name={item?.titleName}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                const regexPhone = (value) => {
                                                    if (+value >= 0 && +value < 100) {
                                                        return true
                                                    } else {
                                                        return 'days should be between 0 - 100'
                                                    }
                                                }
                                                if (!value) {
                                                    return t('required')
                                                } else if (!regexPhone(value)) {
                                                    return '0 - 100'
                                                }
                                            }
                                        }}
                                        render={({ field: { onChange, value } }) => (
                                            <input
                                                disabled={!isInitial}
                                                id={item?.titleName}
                                                name={item?.titleName}
                                                className={cn(
                                                    'input-grc !mt-0 flex h-9 w-[40px] rounded-lg rounded-tr-none rounded-br-none border-none !bg-card px-3 py-3 text-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50'
                                                )}

                                                onChange={(e) => { onChange(e.target.value); onValueChange(item?.configurationTitleId, Number(e.target.value)) }}
                                                value={+item?.values}
                                            />
                                        )} />
                                    <div className={cn('w-full bg-[hsl(var(--primary-table-head))] rounded-tr-[7.5px] rounded-br-[7.5px] text-muted text-sm text-center pt-2'
                                    )}>{item?.subtitleName}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className=' mt-6 text-muted text-lg font-semibold'>Assessment Cycle</div>
                <div className='flex gap-8 items-center'>

                    <div className='w-[27%]'>
                        <div className='flex mt-4 justify-between'>
                            <div className='text-muted text-md font-semibold'>Start Month</div>
                        </div>
                        <div className='w-full'>

                            <SelectInput
                                placeholder="Select"
                                name={'period'}
                                control={control}
                                required
                                readOnly={!isInitial}
                                options={listMonths}
                                value={data.find(el => el.subtitleName === 'Start Month')?.values}
                                className='relative'
                                defaultValue={data.find(el => el.subtitleName === 'Start Month')?.values}
                                onValueChange={value => handleSelect(value, data.find(el => el.subtitleName === 'Start Month')?.configurationTitleId)} />
                        </div>
                    </div>

                    <div className='w-[27%]'>
                        <div className='flex mt-6 justify-between'>
                            <div className='text-muted text-md font-semibold'>End Month</div>
                        </div>
                        <div className='w-full'>

                            <SelectInput
                                placeholder="Select"
                                name={'period'}
                                control={control}
                                required
                                readOnly={true}
                                options={listMonths}
                                value={data.find(el => el.subtitleName === 'End Month')?.values}
                                className='relative'
                                defaultValue={data.find(el => el.subtitleName === 'End Month')?.values}
                                onValueChange={value => handleSelect(value, data.find(el => el.subtitleName === 'End Month')?.configurationTitleId)} />
                        </div>
                    </div>
                    <div className='w-[27%]'>
                        <div className='flex mt-4 justify-between'>
                            <div className='text-muted text-md font-semibold'>Effective Date</div>
                        </div>
                        <div className='flex gap-8 items-center w-full'>

                            <div className='w-full'>
                                <div className='w-full'>
                                    <DatePickerInput
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{ required: 'Effective Date is required' }}
                                        name='Effective Date'
                                        register={register}
                                        disabled={!isInitial}
                                        type="text"
                                        value={intDateConvert(data.find(el => el.subtitleName === 'Effective Date')?.values)}
                                        onValueChange={handleSelectFieldChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end text-grey text-md mt-4">
                    {latestModifiedDate(data)}
                </div>
            </div>}

            {selectedKindId === 2 &&
                <>
                    <div className='flex flex-col gap-4 mt-5'>
                        <div className='flex justify-between'>
                            <div className='text-muted text-lg font-semibold'>{data[0]?.titleName}</div>
                            {/* <div className='text-grey text-sm'>Last Updated: {dayjs(data?.modifiedAt || new Date()).format('DD MMM YYYY, h:mm a')}</div> */}
                        </div>
                        <div>
                            <div className='flex flex-col'>
                                <div className="px-3 py-2">
                                    <Checkbox
                                        disabled={!isInitial}
                                        checked={data[0]?.values === 1}
                                        onCheckedChange={(e) => { onValueChange(data[0]?.configurationTitleId, e === true ? 1 : 0) }}
                                    />
                                    <label className="regulation-list-items-label ml-2">
                                        {data[0]?.subtitleName}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end text-grey text-md mt-4">
                        {latestModifiedDate(data)}
                    </div>
                </>
            }
            {selectedKindId === 3 &&
                (() => {
                    const selectedValue = data?.find((element) => element.values === 1)?.configurationTitleId
                    return (
                        <><div>
                            <div className='flex flex-col gap-4 mt-5'>
                                <div className='flex justify-between'>
                                    <div className='text-muted text-lg font-semibold'>{data[0]?.titleName}</div>
                                    {/* <div className='text-grey text-sm'>Last Updated: {dayjs(data?.modifiedAt || new Date()).format('DD MMM YYYY, h:mm a')}</div> */}
                                </div>
                                <div>
                                    <div className='flex flex-col'>
                                        {data.map((item, index) => (
                                            <>
                                                <div key={index} className="px-3 mb-1 py-2">
                                                    <Checkbox
                                                        disabled={!isInitial}
                                                        checked={item.values === 1}
                                                        onCheckedChange={(e) => { onValueChange(item?.configurationTitleId, e === true ? 1 : 0) }} />
                                                    <label className="regulation-list-items-label ml-2">
                                                        {item?.subtitleName}
                                                    </label>
                                                </div>
                                                {index === 0 && <div className='flex-grow border border-primary-foreground mx-5' />}
                                            </>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className='flex justify-between mt-4'>
                                <div className='text-muted text-lg font-semibold'>Heat Map</div>
                                <div>
                                    <Popover>
                                        <PopoverTrigger>
                                            <BiInfoCircle size={20} className='text-primary' />
                                        </PopoverTrigger>

                                        <PopoverContent
                                            className="w-80 p-3 shadow-lg border rounded-lg"
                                            side="bottom"
                                            align="end"
                                        >
                                            <p className="font-semibold text-primary mb-2">Info</p>
                                            <hr className="border-primary-400 mb-2" />

                                            <div className="space-y-3 text-sm text-gray-700">
                                                <div>
                                                    <p className="font-semibold text-primary">3x3 Heatmap:</p>
                                                    <p>Best For: Initial risk assessments, communicating risk to a broad audience, situations where a quick, top-level view is sufficient.</p>
                                                    <p className="mt-1">Simplicity, High-Level Overview, Ease of Understanding, Less Granular.</p>
                                                </div>
                                                <div>
                                                    <p className="font-semibold text-primary">5x5 Heatmap:</p>
                                                    <p>Best For: More in-depth risk assessments, situations requiring finer distinctions between risk levels, organizations with a more mature risk management framework.</p>
                                                    <p className="mt-1">More Granularity, Detailed Analysis, Better Prioritization, Potentially More Complex.</p>
                                                </div>
                                            </div>

                                        </PopoverContent>
                                    </Popover>

                                </div>
                                {/* <div className='text-grey text-sm'>Last Updated: {dayjs(data?.modifiedAt || new Date()).format('DD MMM YYYY, h:mm a')}</div> */}
                            </div>
                            <RadioGroup className='flex space-x-6 mt-5'
                                defaultValue={selectedValue}
                                onValueChange={(value) => {
                                    setTemporaryConfigurationData(prevState =>
                                        prevState?.map((mapEl) => {
                                            if (mapEl.kindId === 5) {
                                                if (value === mapEl.subtitleName) {
                                                    mapEl.values = 1
                                                } else {
                                                    mapEl.values = 0
                                                }
                                                return mapEl
                                            } else {
                                                return { ...mapEl, status: 2 }
                                            }
                                        })
                                    )
                                }}
                            >
                                {temporaryConfigurationData?.filter(ele => ele.kindId === 5)?.map((header) => {
                                    return (
                                        <div key={header.id} className={`flex items-start space-x-2 p-2  ${selectedValue === header.configurationTitleId ? ' rounded-lg border border-primary bg-primary-500' : ''}`}>
                                            <RadioGroupItem
                                                disabled={!isInitial}
                                                value={header?.subtitleName}
                                                checked={header.values === 1}
                                                id={`radio-${header.configurationTitleId}`} />
                                            <label
                                                htmlFor={`radio-${header.configurationTitleId}`}
                                                className='text-sm'
                                            >
                                                <div className='text-muted text-md font-semibold mb-3'>{header?.subtitleName}</div>
                                                <img src={header?.subtitleName === '3x3 Heat Map' ? '/Common/Icon/FullHeatMap3x3.svg' : '/Common/Icon/FullHeatMap5x5.svg'} />
                                            </label>
                                        </div>
                                    )
                                })}
                            </RadioGroup>
                        </div><div className="flex justify-end text-grey text-md mt-4">
                                {latestModifiedDate(data)}
                            </div></>
                    )
                })()
            }
        </>

    )
}
ConfigurationView.propTypes = {
    selectedKindId: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    onValueChange: PropTypes.func.isRequired
}

export default ConfigurationView
